import {getAnalytics, getHoroscope, getHoroscopeIdentifiers, getHoroscopePageData} from "../../api/app";
import PageDescription from "../../components/baseComponents/head/pageDescription/PageDescription";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useRouter} from "next/router";
import {createMetaData} from "../../utils/data/createMetaData";
import classNames from "classnames";
import {CSSTransition, SwitchTransition, TransitionGroup} from "react-transition-group";
import Head from "next/head";
import {NEXT_PUBLIC_BASE_URL, prediction} from "../../constants/copyright";
import Horoscope from "../../components/horoscope/Horoscope";
import HoroscopeFaq from "../../components/horoscopeFaq/HoroscopeFaq";
import AppearSensor from "../../components/baseComponents/helpers/appearSensor/AppearSensor";
import Narratives from "../../components/narratives/Narratives";
import MoreCards from "../../components/moreCards/MoreCards";
import panel, {addData, changePreloader, usePanel} from "../../redux/reducer/panel";
import {sliceIntoChunks} from "../../utils/sliceIntoChunks";
import Recommendations from "../../components/recommendations/Recommendations";
import {createNewsDate} from "../../utils/data/createData";
import {useDispatch} from "react-redux";
import formatTimestamp from "../../utils/formatTimestamp";
import { unstable_cache } from 'next/cache';
import Preloader from "../../components/baseComponents/gui/preloader/Preloader";

const nameCategory = 'goroskop'

export default function FilterPage({data}) {
  const router = useRouter();
  const {query: {zodiac},asPath} = router;
  const [recordsCount, setRecordsCount] = useState(12)
  const dispatch = useDispatch()
  const {receivedData} = usePanel()


  const {content = {},  narratives = {}, horoscope = {}} = data || {};
  const {headings = []} = data?.header || {};
  const currentCategory = headings.find((item) => {
    return item.href.slice(1) === nameCategory
  })


  const {seo_title, seo_text, image} = currentCategory ?? {}
  console.log(router)
  const canonicalUrl = `${NEXT_PUBLIC_BASE_URL}${asPath}`; // Формирование канонического URL



  const moreClick = () => {
    dispatch(panel.thunks.getMoreArticles({page:nameCategory, recordsCount: recordsCount}))
    setRecordsCount(prev => prev + 6)
  }

  const getDateTest = (ts) => {

    const date =  new Date(ts * 1000).toLocaleString('ru-RU', { day: 'numeric',month:'numeric',year:'numeric', timeZone: 'Europe/Moscow' });
    const dateNow = new Date().toLocaleString('ru-RU', { day: 'numeric', month:'numeric', year:'numeric', timeZone: 'Europe/Moscow' });

    const [day,month,year] = date.split('.')
    const [dayNow,monthNow,yearNow] = dateNow.split('.')

    const dateCombine = month + day + year
    const dateCombineNow = monthNow + dayNow + yearNow

    if (+dateCombine === +dateCombineNow) return "Сегодня";
    if (+dateCombineNow > +dateCombine) return "Вчера";
    if (+dateCombineNow < +dateCombine) return "Завтра";

    return "Неопределено";
  }

  const isDays = horoscope?.period !== 'Week' && horoscope?.period !== 'Month' && horoscope?.period !== 'Year'

  const nameTabs = useCallback( (period, date) => {
    if (period === 'Day') {
      return getDateTest(date)
    }
    if (period === 'Week') {
      return 'неделю'
    }
    if (period === 'Month') {
      return 'Месяц'
    }
    if (period === 'Year') {
      return 'Год'
    }
  },[horoscope])

  const horoscopeTitle = zodiac === 'prediction' ? prediction.title
    : !horoscope?.zodiacSign  ? `Гороскоп для всех знаков на ${nameTabs(horoscope?.period, horoscope?.date)?.toLowerCase()}${isDays ?`: ${formatTimestamp(horoscope?.date)}`: ''}`: `Гороскоп на ${nameTabs(horoscope?.period, horoscope?.date).toLowerCase()}: ${horoscope?.zodiacSign?.title}`


  useEffect(() => {
    dispatch(addData(content.items))
  }, [content.items])

  useEffect(() => {
    dispatch(changePreloader(router.isFallback))
  }, [router.isFallback]);


  const newsList = useMemo(() => {
    const arrData = receivedData?.length ? receivedData : content?.items ;
    return createNewsDate(arrData || [])
  }, [receivedData, content.items])


  const testNarratives = useMemo(() => {
    return narratives.items?.map((item, index) => {
      return {
        index,
        identifier:item.identifier,
        title: item.title,
        image: item.preview,
        imageM: item.preview_mobile,
        color: item.headings[0]?.color === "#ffffff" ? "white" : item.headings[0]?.color,
        tags: [{text: item.headings[0]?.title}],
        list: item.content,
        button: item.button_url || item.button_text ? {
          href: item.button_url,
          text: item.button_text
        } : false
      }
    })
  }, [narratives.items]);

  const recommendationList = sliceIntoChunks(newsList, 6).map((data, index) =>
    <CSSTransition key={`recommendation-${index}`} timeout={1000} classNames={"recommendations"}>
      <Recommendations key={index}
                       index={index}
                       list={data}/>
    </CSSTransition>
  )

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl}/>
        <meta name={'menuCategory'} content={nameCategory}/>
      </Head>
      <div className={'container'}>
        <PageDescription {...createMetaData(horoscopeTitle, seo_text, image, null, null, canonicalUrl, nameCategory)}/>
        { !router.isFallback && <SwitchTransition>
          <CSSTransition key={`filter-${zodiac}`} timeout={500} classNames={"content-page"}>
            <Horoscope data={data} horoscopeTitle={horoscopeTitle}>
              {recommendationList[0]}
              {testNarratives?.length  ? <AppearSensor partialVisibility={true}>
                {({hasBeenVisible}) =>
                  <Narratives list={testNarratives}
                              className={classNames("", {
                                "_show": hasBeenVisible
                              })}/>
                }
              </AppearSensor> : null}
              <TransitionGroup component={null}>
                {[...recommendationList].slice(1)}
              </TransitionGroup>
              <AppearSensor partialVisibility={true}>
                {({isVisible}) =>
                  <MoreCards onClick={moreClick}
                             isShow={isVisible}/>
                }
              </AppearSensor>
            </Horoscope>
          </CSSTransition>
        </SwitchTransition>}
      </div>
      <Preloader/>
    </>
  )
}

const cachedGetHoroscope = unstable_cache(
  async (identifier) => getHoroscope(identifier),
  ['horoscope'],
  { revalidate: 3600, tags: ['horoscope'] }
);

const cachedGetHoroscopePageData = unstable_cache(
  async () => getHoroscopePageData(12),
  ['page-data-goroskop'],
  { revalidate: 3600, tags: ['page-data'] }
);

export async function getStaticPaths() {
  try {
    const identifiers = await getHoroscopeIdentifiers();
    return {
      paths: identifiers.map((zodiac) => ({ params: { zodiac } })),
      fallback: 'blocking',
    };
  } catch (error) {
    console.error('[goroskop] getStaticPaths error', error);
    return {
      paths: [],
      fallback: 'blocking',
    };
  }
}

export async function getStaticProps({ params }) {
  if (!params?.zodiac) return { notFound: true };

  const identifier = params.zodiac;

  try {
    console.log(new Date().toLocaleString(), '[goroskop] getStaticProps', identifier);

    const [analyticsData, horoscopeData, pageData] = await Promise.all([
      getAnalytics(),
      cachedGetHoroscope(identifier),
      cachedGetHoroscopePageData(),
    ]);

    // Жёсткая защита
    if (!pageData?.content?.items?.length || !horoscopeData?.horoscope) {
      console.warn('[goroskop] неполные данные для', identifier);
      return { notFound: true };
    }

    return {
      props: {
        analytic: analyticsData ?? {},
        data: {
          ...pageData,
          ...horoscopeData,
          identifier,
        },
      },
      revalidate: 3600,   // 1 час — идеально для гороскопов
    };
  } catch (error) {
    console.error(new Date().toLocaleString(), '[goroskop] FETCH ERROR', identifier, error);
    return { notFound: true };   // вместо throw — чтобы не падала вся страница
  }
}



